// @flow
export const getDeviceType = (isMobile: boolean, isTablet: boolean): string => {
    if (isMobile) {
        return 'M_WEB';
    }
    if (isTablet) {
        return 'TABLET';
    }
    return 'DESKTOP';
};
